import { useSelector } from "react-redux";

import {
	ANNUITIES_PATH,
	BUSINESS_LENDING_PATH,
	MORTGAGES_PATH,
} from "../../../config/site/ratecompare";
import { BaseTransitionWrapper } from "../../components/BaseComponents/BaseTransitionWrapper";
import { AppProviders } from "../../components/UIComponents/AppProviders";
import { BaseCompanyList } from "../../components/UIComponents/BaseCompanyList";
import { getVertical } from "../../selectors";
import { MortgagesFilters } from "./filtering/MortgagesFilters";
import { MortgagesMultiStepFilteringModal } from "./filtering/MortgagesMultiStepFilteringModal";
import { AnnuitiesCompany } from "./verticals/AnnuitiesCompany";
import { BusinessLendingCompany } from "./verticals/BusinessLending/BusinessLendingCompany";
import { MortgageRatesCompany } from "./verticals/MortgageRatesCompany";
import { styles } from "./verticals/pageLayoutStyles";

const RateCompareCompany = () => {
	const vertical = useSelector(getVertical);

	const componentMap = {
		[ANNUITIES_PATH]: AnnuitiesCompany,
		[BUSINESS_LENDING_PATH]: BusinessLendingCompany,
		[MORTGAGES_PATH]: MortgageRatesCompany,
	};

	const Component = componentMap[vertical];
	if (!Component) {
		return <MortgageRatesCompany />;
	}

	return <Component />;
};

export const App = () => (
	<AppProviders>
		<MortgagesFilters />
		<MortgagesMultiStepFilteringModal />
		<BaseTransitionWrapper>
			<BaseCompanyList styles={styles}>
				<RateCompareCompany />
			</BaseCompanyList>
		</BaseTransitionWrapper>
	</AppProviders>
);
